import React, {useState} from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Tab, Typography, Switch, TextField, Chip,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {DateCalendar, TimePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";

function TodoDialogEditSchedule({ isOpen, onClose, eventTodo, setEventTodo }) {

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();


    const [tabValueSchedule, setTabValueSchedule] = useState("dates");
    const handleTabValueScheduleChange = (event, newValue) => {
        console.log("handleTabValueScheduleChange");
        setTabValueSchedule(newValue);
    };

    const renderDaysLayout = () => {
        const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        // Helper function to get the index of the day of the week (0-6, where 0 = Sunday)
        const getDayOfWeekIndex = (dayName) => daysOfWeek.indexOf(dayName.slice(0, 3));

        // Organize selectedDays into a grid of full weeks (always 7 days per row)
        const weeks = [];
        let currentWeek = Array(7).fill(null); // Start with an empty week (7 slots)

        const eventDays = usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table.days.map(dayObj => {
            // Find the key that starts with "day "
            const dayKey = Object.keys(dayObj).find(k => k.startsWith('day '));
            const dayValue = dayObj[dayKey]; // Will be undefined if key not found, but that's okay

            return { key: dayKey, value: dayValue };
        });

        eventDays.forEach((day) => {
            const dayIndex = getDayOfWeekIndex(day.value); // Get the index (0-6)

            // Place the day into the correct slot in the current week
            currentWeek[dayIndex] = day;

            // If the last day (Saturday) is reached, store the full week and reset
            if (dayIndex === 6) {
                weeks.push([...currentWeek]); // Store a copy of the array
                currentWeek = Array(7).fill(null); // Reset for next week
            }
        });

        // If any days remain, pad the remaining slots and store the last week
        if (currentWeek.some((day) => day !== null)) {
            weeks.push([...currentWeek]);
        }

        return (
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '8px', paddingBottom: '20px' }}>
                {weeks.map((week, weekIndex) => (
                    <Box
                        key={weekIndex}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center', // Centers the week layout
                            gap: '6px', // Small spacing between Chips
                            width: '100%',
                        }}
                    >
                        {week.map((day, dayIndex) => (
                            <Box
                                key={dayIndex}
                                sx={{
                                    flex: '1 1 calc(100% / 7 - 6px)',  // Ensures even width for each slot WITH SPACING
                                    maxWidth: '50px', // Prevents oversized Chips
                                    aspectRatio: '1', // Keeps it square
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                {day ? (
                                    <Chip
                                        label={
                                            <Typography variant="body2" sx={{ textAlign: 'center' }}>
                                                {day.value.slice(0, 2)}
                                            </Typography>
                                        }
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(0, 123, 255, 0.2)',
                                            borderRadius: '10px', // Rounded corners
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    />
                                ) : (
                                    <Chip
                                        label={
                                            <Typography variant="body2" sx={{ textAlign: 'center', color:'#FFF' }}>
                                                {daysOfWeek[0].slice(0, 2)}
                                            </Typography>
                                        }
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgb(251, 251, 251)',
                                            borderRadius: '10px', // Rounded corners
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    />
                                )}
                            </Box>
                        ))}
                    </Box>
                ))}
            </Box>
        );
    };


    const [scheduleDate, setScheduleDate] = useState(eventTodo.schedule_date);
    const [scheduleDay, setScheduleDay] = useState(eventTodo.schedule_day);
    const [scheduleAllDay, setScheduleAllDay] = useState(eventTodo.schedule_all_day);
    const [scheduleBeginTimeSelected, setScheduleBeginTimeSelected] = useState(eventTodo.schedule_begin_time_selected);
    const [scheduleEndTimeSelected, setScheduleEndTimeSelected] = useState(eventTodo.schedule_end_time_selected);
    const [scheduleBeginTime, setScheduleBeginTime] = useState(eventTodo.schedule_begin_time);
    const [scheduleEndTime, setScheduleEndTime] = useState(eventTodo.schedule_end_time);

    function handleScheduleDateChange(schedule_date) {
        setScheduleDate(schedule_date.format('YYYY-MM-DD'));
        setScheduleDay(schedule_date.format('dddd'));
    }
    function handleScheduleDayChange(day) {
        setScheduleDay(day);
    }
    function handleScheduleAllDayChange(event) {
        setScheduleAllDay(event.target.checked);
        if (event.target.checked) {
            // If toggled ON, reset time pickers
            setScheduleBeginTimeSelected(false);
            setScheduleBeginTime("");
            setScheduleEndTimeSelected(false);
            setScheduleEndTime("");
        }
    }
    function handleScheduleBeginTimeChange(time) {
        setScheduleBeginTime(time.format('h:mm A'));
        setScheduleBeginTimeSelected(true);
    }
    function handleScheduleEndTimeChange(time) {
        setScheduleEndTime(time.format('h:mm A'));
        setScheduleEndTimeSelected(true);
    }


    function saveTodoItemSchedule() {
        setEventTodo((prev) => ({
            ...prev,
            schedule_date: scheduleDate,
            schedule_day: scheduleDay,
            schedule_all_day: scheduleAllDay,
            schedule_begin_time_selected: scheduleBeginTimeSelected,
            schedule_end_time_selected: scheduleEndTimeSelected,
            schedule_begin_time: scheduleBeginTime,
            schedule_end_time: scheduleEndTime,
        }));
        onClose();
    }


    return (

        <Dialog open={isOpen} onClose={onClose} PaperProps={{
            sx: {
                minWidth: 350, // or '350px'
                maxWidth: 500, // optional
                width: '100%', // allows it to scale on smaller screens
            },
        }}>
            {/* Dialog Title */}
            <DialogTitle
                sx={{
                    color: '#151269',
                    textAlign: 'center',
                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                    paddingRight: '30px'
                }}
            >
                To-Do Item Schedule
            </DialogTitle>
            {/* Close Button */}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#151269',
                }}
            >
                <i className="icon-cross" style={{ fontSize: '18px', padding: '5px' }} />
            </IconButton>

            {/* Dialog Content */}
            <DialogContent sx={{pt: 2}}>

                <div className="dates-times-selection-list-items-container">
                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                        <TabContext sx={{position: 'relative'}} value={tabValueSchedule}>
                            <Box
                                sx={{
                                    width: '100%',
                                    marginTop: '0',
                                    borderBottom: 1,
                                    borderColor: 'divider',
                                    backgroundColor: 'rgba(251, 251, 251, 0.8)',
                                    backdropFilter: 'blur(6px)',
                                    zIndex: '2'
                                }}
                            >
                                <TabList
                                    centered
                                    variant="fullWidth"
                                    onChange={handleTabValueScheduleChange}
                                    aria-label="Event Dates / Days"
                                >
                                    <Tab
                                        label="Dates"
                                        value="dates"
                                    />
                                    <Tab
                                        label="Days"
                                        value="days"
                                    />
                                </TabList>
                            </Box>


                            {/* Dates Tab Panel */}
                            <TabPanel value="dates" sx={{padding: '0 10px 10px 10px'}}>
                                {/* Schedule Date & Time */}
                                <Box sx={{width: "100%", display: "flex", justifyContent: "center"}}>
                                    <DateCalendar
                                        value={scheduleDate && dayjs(scheduleDate).isValid() ? dayjs(scheduleDate) : dayjs(PA_GlobalObject.Planning['time_table'].dates[0]?.date, 'YYYY-MM-DD').isValid() ? dayjs(PA_GlobalObject.Planning['time_table'].dates[0]?.date, 'YYYY-MM-DD') : dayjs()}
                                        onChange={handleScheduleDateChange}
                                        disablePast={false}
                                        renderLoading={() => <Typography>Loading Calendar...</Typography>}
                                    />
                                </Box>
                            </TabPanel>

                            {/* Days Tab Panel */}
                            <TabPanel value="days" sx={{padding: '0 10px 10px 10px'}}>
                                <Box className="dates-times-selection-times-text"
                                     sx={{marginBottom: '20px'}}>
                                    {renderDaysLayout()}
                                </Box>
                            </TabPanel>
                        </TabContext>

                        <Box sx={{padding: '0 10px'}}>

                            {/* Toggle for All Day */}
                            <Box
                                sx={{
                                    padding: scheduleAllDay ? '0' : '0 0 15px 0'
                                }}
                            >
                                <Switch
                                    checked={scheduleAllDay}
                                    onChange={handleScheduleAllDayChange}
                                    color="primary"
                                />
                                <Typography sx={{fontSize: "14px"}} variant="caption">
                                    No Specific Time
                                </Typography>
                            </Box>

                            {/* Show Time Pickers only when All Day is OFF */}
                            {!scheduleAllDay && (
                                <>
                                    <Typography sx={{fontSize: "14px"}} variant="caption">
                                        Set a time / begin time
                                    </Typography>

                                    <TimePicker
                                        sx={{
                                            margin: "10px 0",
                                            width: "100%",
                                            "& .MuiInputBase-root": {
                                                fontSize: "14px",
                                                padding: "0 8px",
                                                height: "35px",
                                            },
                                            "& .MuiInputLabel-root": {
                                                fontSize: "14px",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                height: "35px",
                                                fontSize: "14px",
                                            },
                                        }}
                                        label="Begin Time"
                                        value={scheduleBeginTime ? dayjs(scheduleBeginTime, "h:mm A") : null}
                                        onChange={handleScheduleBeginTimeChange}
                                        renderInput={(params) => <TextField fullWidth
                                                                            margin="dense" {...params} />}
                                    />

                                    <Typography sx={{fontSize: "14px"}} variant="caption">
                                        Set an end time if there is one
                                    </Typography>

                                    <TimePicker
                                        sx={{
                                            margin: "10px 0",
                                            width: "100%",
                                            "& .MuiInputBase-root": {
                                                fontSize: "14px",
                                                padding: "0 8px",
                                                height: "35px",
                                            },
                                            "& .MuiInputLabel-root": {
                                                fontSize: "14px",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                height: "35px",
                                                fontSize: "14px",
                                            },
                                        }}
                                        label="End Time"
                                        value={scheduleEndTime ? dayjs(scheduleEndTime, "h:mm A") : null}
                                        onChange={handleScheduleEndTimeChange}
                                        renderInput={(params) => <TextField fullWidth
                                                                            margin="dense" {...params} />}
                                    />
                                </>
                            )}

                        </Box>

                    </Box>
                </div>

                <Box sx={{display: 'flex', justifyContent: 'flex-end', mt: 2}}>
                    <Button onClick={onClose} sx={{mr: 1}}>Cancel</Button>
                    <Button variant="contained" onClick={saveTodoItemSchedule}>Save</Button>
                </Box>
            </DialogContent>

        </Dialog>
    )
}

export default TodoDialogEditSchedule;